import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_plane-booking-black.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_o_truck-booking-black.svg'
import _imports_2 from '@/app/ui/assets/svg/ics_o_boat.svg'
import _imports_3 from '@/app/ui/assets/svg/calendar-outlined.svg'


const _hoisted_1 = { class: "flex items-center gap-5" }
const _hoisted_2 = { class: "font-bold text-2xl" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  class: "w-5 h-5",
  alt: "Pesawat"
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1,
  class: "w-5 h-5",
  alt: "Truk"
}
const _hoisted_5 = {
  key: 2,
  src: _imports_2,
  class: "w-5 h-5",
  alt: "Kapal"
}
const _hoisted_6 = { class: "font-bold text-2xl" }
const _hoisted_7 = {
  key: 0,
  class: "flex items-center gap-1.5 font-medium text-gray-lp-800 text-xs rounded-md bg-gray-lp-1000 px-1 py-1 overflow-hidden"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  class: "w-4 h-4",
  alt: "Calendar"
}, null, -1)
const _hoisted_9 = { class: "font-bold text-black-lp-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["flex items-center gap-2", [{ 'pr-6 border-r': _ctx.cargoType === 'plane' && _ctx.departureDate }]],
      style: {"border-color":"#E5E7EB"}
    }, [
      _createVNode("span", _hoisted_2, _toDisplayString(_ctx.origin), 1),
      (_ctx.cargoType === 'plane')
        ? (_openBlock(), _createBlock("img", _hoisted_3))
        : _createCommentVNode("", true),
      (_ctx.cargoType === 'truck')
        ? (_openBlock(), _createBlock("img", _hoisted_4))
        : _createCommentVNode("", true),
      (_ctx.cargoType === 'ship')
        ? (_openBlock(), _createBlock("img", _hoisted_5))
        : _createCommentVNode("", true),
      _createVNode("span", _hoisted_6, _toDisplayString(_ctx.destination), 1)
    ], 2),
    (_ctx.cargoType === 'plane' && _ctx.departureDate)
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          _hoisted_8,
          _createTextVNode(" " + _toDisplayString(_ctx.$t("cargoV2.components.cardRtc.departureStart")) + " ", 1),
          _createVNode("span", _hoisted_9, _toDisplayString(_ctx.departureDate), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}